var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM14.1433 21.6087L13.7833 9.29157H11.0061L10.6204 21.6087H14.1433ZM13.8347 3.99443C13.4404 3.61728 12.9347 3.42871 12.3176 3.42871C11.7347 3.42871 11.2547 3.61728 10.8776 3.99442C10.4833 4.37157 10.2861 4.82585 10.2861 5.35728C10.2861 5.90585 10.4833 6.36871 10.8776 6.74585C11.2547 7.123 11.7347 7.31157 12.3176 7.31157C12.9347 7.31157 13.4404 7.123 13.8347 6.74585C14.2118 6.36871 14.4004 5.90585 14.4004 5.35728C14.4004 4.82585 14.2118 4.37157 13.8347 3.99443Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.14386b71a3d7d48db2a6ed8489654a44.svg";
export { ForwardRef as ReactComponent };